import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const easing = [0.22, 1, 0.36, 1];

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: easing }}
  >
    {children}
  </motion.div>
);

// Masked line reveal — for kinetic headlines
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="line-mask">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: easing }}
    >
      {children}
    </motion.span>
  </span>
);

export const Overline = ({ children, className = "", dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 text-[11px] tracking-[0.28em] uppercase font-bold ${
      dark ? "text-white/60" : "text-[#1C1A17]"
    } ${className}`}
  >
    <span className={`h-px w-6 ${dark ? "bg-white/40" : "bg-[#1C1A17]"}`} />
    {children}
  </span>
);

const baseBtn =
  "group inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-[background-color,color,transform,border-color] duration-300 will-change-transform active:scale-[0.97]";

export const Cta = ({ children, to, onClick, variant = "solid", type, className = "", ...rest }) => {
  const styles = {
    solid: "bg-[#B8935A] text-white hover:bg-[#9C7A44]",
    outline: "border border-black/15 text-[#0A0A0A] hover:border-[#B8935A] hover:text-[#B8935A]",
    light: "bg-white text-[#B8935A] hover:bg-white/90",
    ghost: "border border-white/25 text-white hover:bg-white hover:text-[#B8935A]",
  };
  const cls = `${baseBtn} ${styles[variant]} ${className}`;
  const inner = (
    <>
      {children}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </>
  );
  if (to)
    return (
      <Link to={to} className={cls} {...rest}>
        {inner}
      </Link>
    );
  return (
    <button type={type || "button"} onClick={onClick} className={cls} {...rest}>
      {inner}
    </button>
  );
};

export { easing };
